// App-level buttons that aren't graphic captions — each dispatches to a
// component invoker registered in TXLive (e.g. "Build Subs" → openSubstitutions).
// `group` lists tabs the way a shortcut's group does: [{ name, row, column }].
// A tab with no seat shows the button first.
export const COPILOT_EXTRA_ACTIONS = [
  {
    displayName: "Build Subs",
    opusComponent: "openSubstitutions",
    group: [{ name: "In-Match" }, { name: "HT/FT", row: "6", column: "A" }],
  },
];
